import { restClient0 } from 'myNet'
import { updateToken } from 'services/jwt'
import ResourceService from 'api/Resource'

const commonProps = (attachment, apis) => {
  const self = attachment

  attachment.xhr = null

  if (self.manager != null) {
    self.loading = false
    self.manager.addAttachment(attachment)
  }

  attachment.setLoading = async (loading, reactObj) => {
    if (self.manager != null) {
      self.loading = loading
      self.manager.notifyLoadingChange()
    }
    await reactObj.setLoading(loading)
  }

  attachment.download = async (onProgress, reactObj, options = {}) => {
    await attachment.setLoading(true, reactObj)

    if (attachment.originFile != null && attachment.originFile.blobId == null) {
      const ret = {}

      let blob = attachment.originFile
      const fileName = attachment.originFile.name
      const mimetype = attachment.originFile.type
      let downloadBlob = blob

      if (mimetype != null) {
        downloadBlob = new Blob([blob], { type: mimetype })
      }

      ret.downloadPath = window.URL.createObjectURL(downloadBlob)

      ret.saveFile = () => {
        console.log(' - downloadImg : ', fileName, ret.downloadPath)
        const link = document.createElement('a')
        link.href = ret.downloadPath
        link.download = fileName
        link.click()
        link.remove() // IE 미지원
      }

      if (fileName != null) {
        if (mimetype === 'message/rfc822' || mimetype.indexOf('text/') === 0) {
          ret.text = await blob.text()
        }
      }

      if (fileName != null || mimetype != null) {
        if (blob.type === 'text/xml' && fileName != null) {
          const lcFileName = fileName.toLowerCase()
          if (lcFileName.endsWith('.svg') === true) {
            blob = new Blob([blob], { type: 'image/svg+xml' })
          } else if (
            lcFileName.endsWith('.heic') === true ||
            lcFileName.endsWith('.heif') === true
          ) {
            const tmpFile = new File([blob], fileName, { type: mimetype || 'image/heic' })
            // createObjectURL에는 blob, file 모두 사용가능하므로, file을 blob 대신 전달.
            self.spinning = false
            if (onProgress != null) {
              onProgress(null, null)
            }
            const { default: heictojpeg } = await import('heictojpeg')
            const file = await heictojpeg({ file: tmpFile, quality: 0.9 })
            console.log(file)
            self.spinning = false
            if (onProgress != null) {
              onProgress(null, null)
            }
            ret.path = window.URL.createObjectURL(file)
            attachment.setLoading(false, reactObj)
            return ret
          } else if (mimetype != null) {
            blob = new Blob([blob], { type: mimetype })
          }
        } else if (mimetype != null) {
          blob = new Blob([blob], { type: mimetype })
        }

        ret.blob = blob
        ret.path = window.URL.createObjectURL(blob)
      }

      attachment.setLoading(false, reactObj)
      return ret
    }

    if (attachment.url != null) {
      const { name, type } = attachment.file
      const onBeforeSendNew = (xhr) => {
        xhr.responseType = 'blob'
      }

      let blob
      let isPresigned = false

      const filePathParts = attachment.url?.split('/file/')
      const objectKey = filePathParts?.length > 1 ? filePathParts[1] : null

      if (objectKey && attachment.resourceData?.resource_id) {
        try {
          const purpose = options.extraParams?.includes('preview') ? 'preview' : 'download'

          const result = await ResourceService.getDownloadUrls(
            [{ resource_id: attachment.resourceData.resource_id, object_key: objectKey }],
            purpose,
          )

          const presignedFile = result.data?.files?.[0]
          if (presignedFile?.download_url) {
            const response = await fetch(presignedFile.download_url)
            if (!response.ok) throw new Error(`HTTP ${response.status}`)
            blob = await response.blob()
            isPresigned = true
          }
        } catch (err) {
          console.error('Failed to get presigned URL, falling back to proxy', err)
        }
      }

      if (!isPresigned) {
        const sep = attachment.url.includes('?') ? '&' : '?'
        const downloadUrl = options.extraParams
          ? `${attachment.url}${sep}${options.extraParams}`
          : attachment.url
        const { xhr } = await restClient0.xhrGet(downloadUrl, null, null, onBeforeSendNew)
        console.log('xhrGetFile', xhr)
        blob = xhr.response
      }

      let downloadBlob = new File([blob], name, { type })

      try {
        downloadBlob = await attachment.decode(downloadBlob)
      } catch (e) {
        if (e.code === 401) {
          try {
            await updateToken()
            const { xhr: retryXhr } = await restClient0.xhrGet(
              attachment.url,
              null,
              null,
              onBeforeSendNew,
            )
            blob = retryXhr.response
            downloadBlob = new File([blob], name, { type })
            downloadBlob = await attachment.decode(downloadBlob)
          } catch (retryError) {
            console.error('decode error after token refresh - ', retryError)
            attachment.setLoading(false, reactObj)
            throw retryError
          }
        } else {
          console.error('decode error - ', e)
          attachment.setLoading(false, reactObj)
          throw e
        }
      }

      const ret = {
        downloadPath: window.URL.createObjectURL(downloadBlob),
        arrayBuffer: await downloadBlob.arrayBuffer(),
      }

      ret.saveFile = () => {
        console.log(' - downloadImg : ', name, ret.downloadPath)
        const link = document.createElement('a')
        link.href = ret.downloadPath
        link.download = name
        link.click()
        link.remove() // IE 미지원
      }

      if (name != null) {
        if (type === 'message/rfc822' || type.indexOf('text/') === 0) {
          ret.text = await blob.text()
        }
      }

      if (name != null || type != null) {
        if (blob.type === 'text/xml' && name != null) {
          const lcFileName = name.toLowerCase()
          if (lcFileName.endsWith('.svg') === true) {
            blob = new Blob([blob], { type: 'image/svg+xml' })
          } else if (
            lcFileName.endsWith('.heic') === true ||
            lcFileName.endsWith('.heif') === true
          ) {
            const tmpFile = new File([blob], name, { type: type || 'image/heic' })
            // createObjectURL에는 blob, file 모두 사용가능하므로, file을 blob 대신 전달.
            self.spinning = false
            if (onProgress != null) {
              onProgress(null, null)
            }
            const { default: heictojpeg } = await import('heictojpeg')
            const file = await heictojpeg({ file: tmpFile, quality: 0.9 })
            console.log(file)
            self.spinning = false
            if (onProgress != null) {
              onProgress(null, null)
            }
            ret.path = window.URL.createObjectURL(file)

            attachment.setLoading(false, reactObj)
            return ret
          } else if (type != null) {
            blob = new Blob([blob], { type })
          }
        } else if (type != null) {
          blob = new Blob([blob], { type })
        }

        ret.path = window.URL.createObjectURL(blob)
      }

      attachment.setLoading(false, reactObj)
      return ret
    }

    return null
  }

  attachment.cancelDownload = () => {
    if (attachment.xhr != null) {
      try {
        attachment.xhr.abort()
      } catch (err) {
        console.log(err)
      }
      attachment.xhr = null
    }
  }

  attachment.delete = () => {
    if (apis.deleteAttachment != null) {
      apis.deleteAttachment(attachment)

      if (self.manager != null) {
        self.manager.notifyLengthChange()
      }
    }
  }

  attachment.compare = (other) => {
    let ret = false
    if (attachment === other) {
      ret = true
    } else if (
      attachment.file.blobId !== other.file.blobId ||
      attachment.file.name !== other.file.name ||
      attachment.file.size !== other.file.size ||
      attachment.file.type !== other.file.type
    ) {
      ret = false
    }
    return ret
  }

  attachment.encode = (onEnd) => {
    return new Promise((resolve) => {
      const { name, type } = attachment.file

      const reader = new FileReader()

      reader.addEventListener(
        'load',
        async () => {
          console.log(' -- buffer : ', reader.result)
          const encrypted = await attachment.rsKeyObj.encryptBytes(reader.result)
          console.log(' -- encrypted : ', encrypted.length, encrypted)
          const etag = attachment.rsKeyObj.md5(encrypted)
          console.log(' -- etag : ', etag)

          const uint8Array = Uint8Array.from(encrypted, (c) => c.charCodeAt(0))

          const encodedFile = new File([uint8Array], name, { type })

          attachment.encodedFile = encodedFile
          attachment.etag = etag

          if (onEnd != null) {
            onEnd({ encrypted, encodedFile })
          }

          resolve(attachment)
        },
        false,
      )

      reader.readAsArrayBuffer(attachment.originFile)
    })
  }

  attachment.decode = (file, onEnd) => {
    return new Promise((resolve, reject) => {
      const { name, type } = attachment.file

      const reader = new FileReader()

      reader.addEventListener(
        'load',
        async () => {
          // console.log(' -- buffer2 : ', reader.result);
          const bytes = new Uint8Array(reader.result)

          // 길이가 100byte 이하인 경우, 에러인지 확인.
          if (bytes.length < 100 || bytes.length > 10485760) {
            // 10MB = 10 * 1024 * 1024
            const jsonStr = String.fromCharCode(...new Uint8Array(reader.result))

            try {
              const jsonObj = JSON.parse(jsonStr)
              const { code, message } = jsonObj
              if (code != null && code !== 200) {
                console.error(' -- error : ', code, message)
                const error = new Error(message)
                error.code = code
                reject(error)
                return
              }
            } catch (e) {
              // 정상적인 상태면 parsing이 되지 않는다.
              console.log('success')
            }
          }

          let binaryStr = ''
          for (let i = 0; i < Math.ceil(bytes.length / 32768.0); i += 1) {
            binaryStr += String.fromCharCode.apply(
              null,
              bytes.slice(i * 32768, Math.min((i + 1) * 32768, bytes.length)),
            )
          }
          const decrypted = await attachment.rsKeyObj.decryptBytes(binaryStr)

          console.log(' -- decrypted : ', decrypted)

          const uint8Array = Uint8Array.from(decrypted, (c) => c.charCodeAt(0))
          const decodedFile = new File([uint8Array], name, { type })

          if (onEnd != null) {
            onEnd({ decrypted, decodedFile })
          }

          resolve(decodedFile)
        },
        false,
      )

      reader.readAsArrayBuffer(file)
    })
  }

  return self
}

const createAttachment = (originFile, rsKeyObj, apis, manager) => {
  const { name, size, type } = originFile
  const attachment = {
    file: {
      name,
      size,
      type: type != null && type.length > 0 ? type : 'application/unknown',
    },
    key: `${name}_${size}`,
    originFile,
    uploaded: false,
    rsKeyObj,
    manager,
  }

  attachment.startEncoding = async (reactObj) => {
    await attachment.setLoading(true, reactObj)

    setTimeout(() => {
      attachment.encode(() => {
        attachment.setLoading(false, reactObj)
      })
    }, 50)
  }

  commonProps(attachment, apis)

  return attachment
}

const createAttachmentByResource = (resourceData, rsKeyObj, apis, manager) => {
  const { filename: name, size, content_type: type, id, url } = resourceData
  const attachment = {
    file: {
      name,
      size,
      type,
    },
    key: id,
    resourceData,
    uploaded: true,
    url,
    rsKeyObj,
    manager,
  }

  commonProps(attachment, apis)

  return attachment
}

function AttachmentManager() {
  const self = this

  self.attachmentList = []
  self.changeListeners = []

  self.addAttachment = (attachment) => {
    self.attachmentList.push(attachment)
    self.notifyLengthChange()
  }

  self.removeAttachment = (attachment) => {
    const pos = self.attachmentList.indexOf(attachment)
    if (pos >= 0) {
      self.attachmentList.splice(pos, 1)
      self.notifyLengthChange()
    }
  }

  self.notifyLoadingChange = () => {
    const isLoading = self.attachmentList.some((attachment) => {
      return attachment.loading === true
    })

    self.changeListeners.forEach((listenerObj) => {
      listenerObj.loadingChanged(isLoading)
    })
  }

  self.notifyLengthChange = () => {
    self.changeListeners.forEach((listenerObj) => {
      listenerObj.lengthChanged(self.attachmentList.length)
    })
  }

  self.addChangeListener = (listenerObj) => {
    self.changeListeners.push(listenerObj)
  }

  self.removeChangeListener = (listenerObj) => {
    const pos = self.changeListeners.indexOf(listenerObj)
    if (pos >= 0) {
      self.changeListeners.splice(pos, 1)
    }
  }
}

const createAttachmentManager = (listenerObj) => {
  const attachmentManager = new AttachmentManager()
  attachmentManager.addChangeListener(listenerObj)

  return attachmentManager
}

function isPreviewEnable(file) {
  console.log('isPreviewEnable - ', file)

  if (file != null && file.type != null) {
    const { type } = file

    const mimeType = type.toLowerCase()

    const types = mimeType.split('/')

    switch (types[0]) {
      case 'image':
      case 'video':
      case 'audio':
      case 'text':
        return true
      default:
    }

    switch (mimeType) {
      case 'message/rfc822':
      case 'text/plain':
      case 'text/xml':
        return true
      default:
    }
  }

  return false
}

export const DRAGDOCS_EXTENSIONS = new Set([
  'hwp',
  'hwpx',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'odt',
  'pdf',
])

const TEXT_EXTENSIONS = new Set(['md', 'csv', 'log', 'json', 'xml', 'yaml', 'yml', 'txt'])

function getFileExtension(fileName) {
  if (!fileName) return ''
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot < 0) return ''
  return fileName.substring(lastDot + 1).toLowerCase()
}

function isTextViewable(file) {
  if (!file || !file.name) return false
  return TEXT_EXTENSIONS.has(getFileExtension(file.name))
}

function isViewEnabled(file) {
  if (!file || !file.name) return false
  const ext = getFileExtension(file.name)
  return DRAGDOCS_EXTENSIONS.has(ext) || TEXT_EXTENSIONS.has(ext)
}

function isNotDragDocsExtension(file) {
  if (!file || !file.name) return true
  const ext = getFileExtension(file.name)
  return !DRAGDOCS_EXTENSIONS.has(ext) && !TEXT_EXTENSIONS.has(ext)
}

const helper = {
  createAttachment,
  createAttachmentByResource,
  createAttachmentManager,
  isPreviewEnable,
  isTextViewable,
  isViewEnabled,
  isNotDragDocsExtension,
}

export default helper
